// Core Rulebook Trade Goods.
const tradeGoods = [
  { name: 'Wheat', category: 'Trade Goods', cost: '1 cp', weight: '1 lb.', description: '' },
  { name: 'Flour', category: 'Trade Goods', cost: '2 cp', weight: '1 lb.', description: '' },
  { name: 'Chicken (Live)', category: 'Trade Goods', cost: '2 cp', weight: '—', description: '' },
  { name: 'Iron', category: 'Trade Goods', cost: '1 sp', weight: '1 lb.', description: '' },
  { name: 'Tobacco', category: 'Trade Goods', cost: '5 sp', weight: '1 lb.', description: '' },
  { name: 'Copper', category: 'Trade Goods', cost: '5 sp', weight: '1 lb.', description: '' },
  { name: 'Cinnamon', category: 'Trade Goods', cost: '1 gp', weight: '1 lb.', description: '' },
  { name: 'Goat (Live)', category: 'Trade Goods', cost: '1 gp', weight: '—', description: '' },
  { name: 'Ginger', category: 'Trade Goods', cost: '2 gp', weight: '1 lb.', description: '' },
  { name: 'Pepper', category: 'Trade Goods', cost: '2 gp', weight: '1 lb.', description: '' },
  { name: 'Sheep (Live)', category: 'Trade Goods', cost: '2 gp', weight: '—', description: '' },
  { name: 'Pig (Live)', category: 'Trade Goods', cost: '3 gp', weight: '—', description: '' },
  { name: 'Linen (Sq. Yard)', category: 'Trade Goods', cost: '4 gp', weight: '—', description: '' },
  { name: 'Salt', category: 'Trade Goods', cost: '5 gp', weight: '1 lb.', description: '' },
  { name: 'Silver', category: 'Trade Goods', cost: '5 gp', weight: '1 lb.', description: '' },
  { name: 'Silk (Sq. Yard)', category: 'Trade Goods', cost: '10 gp', weight: '—', description: '' },
  { name: 'Cow (Live)', category: 'Trade Goods', cost: '10 gp', weight: '—', description: '' },
  { name: 'Saffron', category: 'Trade Goods', cost: '15 gp', weight: '1 lb.', description: '' },
  { name: 'Cloves', category: 'Trade Goods', cost: '15 gp', weight: '1 lb.', description: '' },
  { name: 'Ox (Live)', category: 'Trade Goods', cost: '15 gp', weight: '—', description: '' },
  { name: 'Gold', category: 'Trade Goods', cost: '50 gp', weight: '1 lb.', description: '' },
  { name: 'Platinum', category: 'Trade Goods', cost: '500 gp', weight: '1 lb.', description: '' },
];

export default tradeGoods;
